module.exports = __webpack_public_path__ + "img/3-l.7e5850b6.png";